import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import clsx from "clsx";

import Button from "components/Button";
import { JOIN_DOCS_TYPE_LIST } from "constants/haulpay";
import { useUserFeature } from "hooks/useUserFeature";
import { IPlaidAccount } from "models/HaulPay";
import { IUserInfoForm } from "models/User";
import { selectUserDetails } from "store/user/selector";
import styles from "./style.module.scss";
import UploadDocItem from "./UploadDocItem";

interface IProps {
  submitData?: IUserInfoForm & {
    factoring_id?: string;
    bank_accounts?: IPlaidAccount[];
  };
  onNext?: (documents: { [key in string]: any }) => void;
}

export default function JoinDocs({ submitData, onNext }: Readonly<IProps>) {
  const { isCarrier } = useUserFeature();
  const { pathname } = useLocation();
  const [uploadedDocuments, setUploadedDocuments] = useState({});
  const userDetails = useSelector(selectUserDetails);

  const fromHomePage = pathname.includes("upload-docs");

  const docsList = isCarrier
    ? JOIN_DOCS_TYPE_LIST.filter(
        (item) => item.category !== "certificate" && item.category !== "w9"
      )
    : JOIN_DOCS_TYPE_LIST;

  return (
    <form className={clsx(styles.docsContainer, fromHomePage && "mobile:pb-20")}>
      <div className="mb-6">
        <h3 className={clsx(styles.header, fromHomePage && "hidden")}>Docs</h3>

        <ul className={styles.list}>
          {docsList.map((item) => (
            <UploadDocItem
              key={item.title}
              data={item}
              factoring_id={fromHomePage ? userDetails?.factoring_id : submitData?.factoring_id}
              onDocumentUploaded={
                fromHomePage ? undefined : (doc) => setUploadedDocuments({ [item.category]: doc })
              }
            />
          ))}
        </ul>
      </div>

      {!fromHomePage && (
        <div className={styles.footer}>
          <Button size="lg" onClick={() => onNext && onNext(uploadedDocuments)}>
            NEXT
          </Button>
        </div>
      )}
    </form>
  );
}
